<template>
  <div class="home">
    <vue-particles 
      color="#33266e"
      :particleOpacity="0.2"
      :particlesNumber="12"
      shapeType="circle"
      :particleSize="0"
      linesColor="#33266e"
      :linesWidth="200"
      :lineLinked="true"
      :lineOpacity="0.2"
      :linesDistance="400"
      :moveSpeed="1.5"
      :hoverEffect="false"
      :clickEffect="false"
    ></vue-particles>
    <HomeContentWithImage />
    <HomeCardsWithContent />
    <HomeContentWithCards />
    <ContentWithNewsletter />
    <ContentFromRadionica />
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {
    'HomeContentWithImage': () => import(/* webpackChunkName: "Home" */'@/components/HomeContentWithImage'),
    'HomeCardsWithContent': () => import(/* webpackChunkName: "Home" */'@/components/HomeCardsWithContent'),
    'HomeContentWithCards': () => import(/* webpackChunkName: "Home" */'@/components/HomeContentWithCards'),
    'ContentWithNewsletter': () => import(/* webpackChunkName: "Home" */'@/components/ContentWithNewsletter'),
    'ContentFromRadionica': () => import(/* webpackChunkName: "Home" */'@/components/ContentFromRadionica'),
  },
}
</script>
<style scoped lang="scss">
  #particles-js {
    height: 100vh;
    position: fixed;
    top: 0px;
    width: 100vw;
    z-index: 1;
  }
</style>
